<div class="image-container">
	<div nz-row class="j-c-center">
		<div nz-row>
			<svg width="110" height="77" viewBox="0 0 110 77" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g clip-path="url(#clip0_4586_35659)">
					<path
						d="M52.866 61.9667C69.7231 61.9667 83.4585 48.2881 83.4585 31.4877C83.4018 14.6306 69.7231 0.951904 52.866 0.951904C35.9521 0.951904 22.2734 14.6306 22.2734 31.4309C22.2734 48.2881 35.9521 61.9667 52.866 61.9667Z"
						fill="#0357EE" fill-opacity="0.1" />
					<g filter="url(#filter0_d_4586_35659)">
						<path
							d="M99.7598 52.6874C99.7598 57.6136 95.776 61.5973 90.807 61.5973C90.7213 61.5973 89.9931 61.5973 84.6386 61.5973C80.9118 61.5973 74.9576 61.5973 65.4479 61.5973H60.9073C54.9531 61.7258 50.1982 56.971 50.1982 51.231C50.1982 45.4481 54.9959 40.6504 61.0358 40.9503C66.219 24.7582 89.9503 27.0285 91.9636 43.7775C96.4185 44.3343 99.7598 48.1039 99.7598 52.6874Z"
							fill="url(#paint0_linear_4586_35659)" />
					</g>
					<path
						d="M90.8073 61.5972C95.7334 61.5972 99.76 57.6134 99.76 52.6873C99.76 47.7611 95.7334 43.7773 90.8073 43.7773C85.8811 43.7773 81.8545 47.7611 81.8545 52.6873C81.8545 57.6134 85.8811 61.5972 90.8073 61.5972Z"
						fill="url(#paint1_linear_4586_35659)" />
					<path
						d="M76.1997 61.6829C84.9811 61.6829 92.1348 54.5721 92.1348 45.7907C92.1348 37.0092 84.9811 29.8984 76.1997 29.8984C67.4183 29.8984 60.2646 37.0092 60.2646 45.7907C60.2646 54.5721 67.3755 61.6829 76.1997 61.6829Z"
						fill="url(#paint2_linear_4586_35659)" />
					<g filter="url(#filter1_d_4586_35659)">
						<path
							d="M52.3817 19.35C52.3817 23.5724 48.967 26.9871 44.7079 26.9871C44.6344 26.9871 44.0103 26.9871 39.4207 26.9871C36.2263 26.9871 31.1227 26.9871 22.9716 26.9871H19.0796C13.976 27.0972 9.90039 23.0217 9.90039 18.1016C9.90039 13.1448 14.0127 9.03257 19.1897 9.28959C23.6325 -4.58935 43.9735 -2.64336 45.6992 11.7129C49.5178 12.1902 52.3817 15.4213 52.3817 19.35Z"
							fill="url(#paint3_linear_4586_35659)" />
					</g>
					<path
						d="M44.708 26.9871C48.9304 26.9871 52.3818 23.5724 52.3818 19.35C52.3818 15.1275 48.9304 11.7129 44.708 11.7129C40.4856 11.7129 37.0342 15.1275 37.0342 19.35C37.0342 23.5724 40.4856 26.9871 44.708 26.9871Z"
						fill="url(#paint4_linear_4586_35659)" />
					<path
						d="M32.1879 27.0605C39.7149 27.0605 45.8466 20.9655 45.8466 13.4386C45.8466 5.91163 39.7149 -0.18335 32.1879 -0.18335C24.661 -0.18335 18.5293 5.91163 18.5293 13.4386C18.5293 20.9655 24.6243 27.0605 32.1879 27.0605Z"
						fill="url(#paint5_linear_4586_35659)" />
					<g filter="url(#filter2_d_4586_35659)">
						<path
							d="M78.4522 20.5387C78.4522 23.1777 76.318 25.3118 73.656 25.3118C73.6102 25.3118 73.22 25.3118 70.3515 25.3118C68.3551 25.3118 65.1653 25.3118 60.0708 25.3118H57.6384C54.4486 25.3807 51.9014 22.8334 51.9014 19.7584C51.9014 16.6604 54.4715 14.0903 57.7072 14.2509C60.4839 5.57657 73.1971 6.79282 74.2756 15.7655C76.6622 16.0638 78.4522 18.0832 78.4522 20.5387Z"
							fill="url(#paint6_linear_4586_35659)" />
					</g>
					<path
						d="M73.6565 25.3117C76.2955 25.3117 78.4526 23.1776 78.4526 20.5386C78.4526 17.8995 76.2955 15.7654 73.6565 15.7654C71.0175 15.7654 68.8604 17.8995 68.8604 20.5386C68.8604 23.1776 71.0175 25.3117 73.6565 25.3117Z"
						fill="url(#paint7_linear_4586_35659)" />
					<path
						d="M65.8306 25.3577C70.5349 25.3577 74.3672 21.5484 74.3672 16.844C74.3672 12.1397 70.5349 8.33032 65.8306 8.33032C61.1263 8.33032 57.2939 12.1397 57.2939 16.844C57.2939 21.5484 61.1033 25.3577 65.8306 25.3577Z"
						fill="url(#paint8_linear_4586_35659)" />
					<g filter="url(#filter3_d_4586_35659)">
						<path
							d="M69.5177 20.5021L69.9136 52.3742C69.9136 53.463 69.0228 54.3044 67.934 54.3044H36.8537C35.7649 54.3044 34.874 53.4136 34.874 52.3742V11.3957C34.874 10.3069 35.7649 9.46558 36.8537 9.46558H59.372L69.5177 20.5021Z"
							fill="url(#paint9_linear_4586_35659)" />
					</g>
					<path
						d="M49.7375 47.4934H49.1007C48.9623 47.4934 48.8516 47.3644 48.8516 47.2096C48.8516 47.0548 48.9623 46.9258 49.1007 46.9258H49.7375C49.876 46.9258 49.9867 47.0548 49.9867 47.2096C49.9867 47.3902 49.876 47.4934 49.7375 47.4934Z"
						fill="#CED7E2" />
					<path
						d="M46.1782 47.4934H40.1738C39.9497 47.4934 39.7705 47.3644 39.7705 47.2096C39.7705 47.0548 39.9497 46.9258 40.1738 46.9258H46.1782C46.4022 46.9258 46.5815 47.0548 46.5815 47.2096C46.5815 47.3902 46.4022 47.4934 46.1782 47.4934Z"
						fill="#D5DDEA" />
					<path
						d="M55.0309 16.2765H40.4023C40.0621 16.2765 39.7705 16.0146 39.7705 15.7089C39.7705 15.4033 40.0621 15.1414 40.4023 15.1414H55.0309C55.3711 15.1414 55.6627 15.4033 55.6627 15.7089C55.6627 16.0146 55.3711 16.2765 55.0309 16.2765Z"
						fill="#D5DDEA" />
					<path
						d="M46.0018 19.682H40.3985C40.0603 19.682 39.7705 19.4201 39.7705 19.1145C39.7705 18.8088 40.0603 18.5469 40.3985 18.5469H45.9535C46.2916 18.5469 46.5815 18.8088 46.5815 19.1145C46.5815 19.4201 46.2916 19.682 46.0018 19.682Z"
						fill="#D5DDEA" />
					<path d="M59.4912 9.46558V18.5265C59.4912 19.7991 60.5876 20.8172 61.8335 20.8172L69.4958 20.5334"
						fill="#9BA6B9" />
					<path
						d="M47.302 25.6495C48.7376 24.7292 50.4309 24.2139 52.2347 24.2139C57.1674 24.2139 61.1799 28.1895 61.1799 33.1222C61.1799 38.055 57.1674 42.0306 52.2347 42.0306C47.302 42.0306 43.2895 38.055 43.2895 33.1222C43.2159 29.9933 44.8356 27.2692 47.302 25.6495Z"
						fill="url(#paint10_linear_4586_35659)" />
					<path
						d="M52.8779 29.0511L55.4367 31.8479C55.7378 32.1769 55.7378 32.7527 55.4367 33.0817C55.1357 33.4108 54.6089 33.4108 54.2702 33.0817L53.1037 31.8479V36.372C53.1037 36.8656 52.7274 37.2769 52.2759 37.2769C51.8243 37.2769 51.448 36.8656 51.448 36.372V31.8479L50.2815 33.0817C49.9805 33.4108 49.4536 33.4108 49.115 33.0817C48.9268 32.8761 48.8516 32.6704 48.8516 32.4648C48.8516 32.2591 48.9268 31.9712 49.115 31.8479L51.6738 29.0511C51.7867 28.9277 52.0501 28.7632 52.2382 28.7632C52.4264 28.7632 52.765 28.8454 52.8779 29.0511Z"
						fill="white" />
					<g filter="url(#filter4_d_4586_35659)">
						<path
							d="M43.2617 39.2689C43.2617 41.9079 41.1276 44.0421 38.4656 44.0421C38.4197 44.0421 38.0296 44.0421 35.1611 44.0421C33.1646 44.0421 29.9749 44.0421 24.8804 44.0421H22.4479C19.2582 44.1109 16.7109 41.5637 16.7109 38.4886C16.7109 35.3907 19.2811 32.8205 22.5168 32.9811C25.2935 24.3068 38.0067 25.523 39.0852 34.4957C41.4718 34.794 43.2617 36.8134 43.2617 39.2689Z"
							fill="url(#paint11_linear_4586_35659)" />
					</g>
					<path
						d="M38.466 44.042C41.1051 44.042 43.2622 41.9078 43.2622 39.2688C43.2622 36.6298 41.1051 34.4956 38.466 34.4956C35.827 34.4956 33.6699 36.6298 33.6699 39.2688C33.6699 41.9078 35.827 44.042 38.466 44.042Z"
						fill="url(#paint12_linear_4586_35659)" />
					<path
						d="M30.6402 44.0879C35.3445 44.0879 39.1768 40.2786 39.1768 35.5742C39.1768 30.8699 35.3445 27.0605 30.6402 27.0605C25.9358 27.0605 22.1035 30.8699 22.1035 35.5742C22.1035 40.2786 25.9129 44.0879 30.6402 44.0879Z"
						fill="url(#paint13_linear_4586_35659)" />
				</g>
				<defs>
					<filter id="filter0_d_4586_35659" x="38.0982" y="23.8873" width="73.7615" height="55.8626"
						filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
						<feFlood flood-opacity="0" result="BackgroundImageFix" />
						<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
							result="hardAlpha" />
						<feOffset dy="6.05" />
						<feGaussianBlur stdDeviation="6.05" />
						<feColorMatrix type="matrix"
							values="0 0 0 0 0.319965 0 0 0 0 0.532231 0 0 0 0 0.791667 0 0 0 0.27 0" />
						<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4586_35659" />
						<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4586_35659" result="shape" />
					</filter>
					<filter id="filter1_d_4586_35659" x="-2.19961" y="-6.20015" width="66.6814" height="51.3394"
						filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
						<feFlood flood-opacity="0" result="BackgroundImageFix" />
						<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
							result="hardAlpha" />
						<feOffset dy="6.05" />
						<feGaussianBlur stdDeviation="6.05" />
						<feColorMatrix type="matrix"
							values="0 0 0 0 0.321569 0 0 0 0 0.533333 0 0 0 0 0.792157 0 0 0 0.24 0" />
						<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4586_35659" />
						<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4586_35659" result="shape" />
					</filter>
					<filter id="filter2_d_4586_35659" x="39.8014" y="2.30107" width="50.7508" height="41.1622"
						filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
						<feFlood flood-opacity="0" result="BackgroundImageFix" />
						<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
							result="hardAlpha" />
						<feOffset dy="6.05" />
						<feGaussianBlur stdDeviation="6.05" />
						<feColorMatrix type="matrix"
							values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0" />
						<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4586_35659" />
						<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4586_35659" result="shape" />
					</filter>
					<filter id="filter3_d_4586_35659" x="22.774" y="3.41558" width="59.24" height="69.0389"
						filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
						<feFlood flood-opacity="0" result="BackgroundImageFix" />
						<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
							result="hardAlpha" />
						<feOffset dy="6.05" />
						<feGaussianBlur stdDeviation="6.05" />
						<feColorMatrix type="matrix"
							values="0 0 0 0 0.266406 0 0 0 0 0.455899 0 0 0 0 0.6875 0 0 0 0.27 0" />
						<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4586_35659" />
						<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4586_35659" result="shape" />
					</filter>
					<filter id="filter4_d_4586_35659" x="4.61094" y="21.0313" width="50.7508" height="41.1622"
						filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
						<feFlood flood-opacity="0" result="BackgroundImageFix" />
						<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
							result="hardAlpha" />
						<feOffset dy="6.05" />
						<feGaussianBlur stdDeviation="6.05" />
						<feColorMatrix type="matrix"
							values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0" />
						<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4586_35659" />
						<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4586_35659" result="shape" />
					</filter>
					<linearGradient id="paint0_linear_4586_35659" x1="74.979" y1="43.0215" x2="74.9628" y2="61.9412"
						gradientUnits="userSpaceOnUse">
						<stop stop-color="white" />
						<stop offset="0.9964" stop-color="#ECF0F5" />
					</linearGradient>
					<linearGradient id="paint1_linear_4586_35659" x1="80.9018" y1="41.8591" x2="88.8383" y2="50.5393"
						gradientUnits="userSpaceOnUse">
						<stop stop-color="#BCCBE1" />
						<stop offset="0.9942" stop-color="white" stop-opacity="0" />
					</linearGradient>
					<linearGradient id="paint2_linear_4586_35659" x1="58.7725" y1="38.4981" x2="71.2812" y2="43.3932"
						gradientUnits="userSpaceOnUse">
						<stop stop-color="#E2E8F0" />
						<stop offset="0.9942" stop-color="white" stop-opacity="0" />
					</linearGradient>
					<linearGradient id="paint3_linear_4586_35659" x1="31.141" y1="11.0649" x2="31.1272" y2="27.2818"
						gradientUnits="userSpaceOnUse">
						<stop stop-color="white" />
						<stop offset="0.9964" stop-color="#ECF0F5" />
					</linearGradient>
					<linearGradient id="paint4_linear_4586_35659" x1="36.2176" y1="10.0686" x2="43.0203" y2="17.5088"
						gradientUnits="userSpaceOnUse">
						<stop stop-color="#BCCBE1" />
						<stop offset="0.9942" stop-color="white" stop-opacity="0" />
					</linearGradient>
					<linearGradient id="paint5_linear_4586_35659" x1="17.2503" y1="7.18783" x2="27.9721" y2="11.3836"
						gradientUnits="userSpaceOnUse">
						<stop stop-color="#E2E8F0" />
						<stop offset="0.9942" stop-color="white" stop-opacity="0" />
					</linearGradient>
					<linearGradient id="paint6_linear_4586_35659" x1="65.1768" y1="15.3605" x2="65.1681" y2="25.4961"
						gradientUnits="userSpaceOnUse">
						<stop stop-color="white" />
						<stop offset="0.9964" stop-color="#ECF0F5" />
					</linearGradient>
					<linearGradient id="paint7_linear_4586_35659" x1="68.35" y1="14.7377" x2="72.6017" y2="19.3878"
						gradientUnits="userSpaceOnUse">
						<stop stop-color="#BCCBE1" />
						<stop offset="0.9942" stop-color="white" stop-opacity="0" />
					</linearGradient>
					<linearGradient id="paint8_linear_4586_35659" x1="56.4946" y1="12.9373" x2="63.1957" y2="15.5597"
						gradientUnits="userSpaceOnUse">
						<stop stop-color="#E2E8F0" />
						<stop offset="0.9942" stop-color="white" stop-opacity="0" />
					</linearGradient>
					<linearGradient id="paint9_linear_4586_35659" x1="52.3824" y1="8.42841" x2="52.3824" y2="54.7878"
						gradientUnits="userSpaceOnUse">
						<stop stop-color="#FDFEFF" />
						<stop offset="0.9964" stop-color="#ECF0F5" />
					</linearGradient>
					<linearGradient id="paint10_linear_4586_35659" x1="44.6981" y1="25.6213" x2="59.7042" y2="40.6914"
						gradientUnits="userSpaceOnUse">
						<stop stop-color="#05C2FF" />
						<stop offset="1" stop-color="#0357EE" />
					</linearGradient>
					<linearGradient id="paint11_linear_4586_35659" x1="29.9863" y1="34.0907" x2="29.9777" y2="44.2263"
						gradientUnits="userSpaceOnUse">
						<stop stop-color="white" />
						<stop offset="0.9964" stop-color="#ECF0F5" />
					</linearGradient>
					<linearGradient id="paint12_linear_4586_35659" x1="33.1595" y1="33.4679" x2="37.4113" y2="38.1181"
						gradientUnits="userSpaceOnUse">
						<stop stop-color="#BCCBE1" />
						<stop offset="0.9942" stop-color="white" stop-opacity="0" />
					</linearGradient>
					<linearGradient id="paint13_linear_4586_35659" x1="21.3041" y1="31.6675" x2="28.0052" y2="34.2899"
						gradientUnits="userSpaceOnUse">
						<stop stop-color="#E2E8F0" />
						<stop offset="0.9942" stop-color="white" stop-opacity="0" />
					</linearGradient>
					<clipPath id="clip0_4586_35659">
						<rect width="110" height="76" fill="white" transform="translate(0 0.166748)" />
					</clipPath>
				</defs>
			</svg>
		</div>
		<div nz-row class="desc">
			Drag your documents or photos here to start uploading
		</div>
		<div nz-row class="detail">
			<div nz-col nzSpan="12" class="format">
				{{format}}
			</div>
			<div nz-col nzSpan="12" class="size">
				Max Filesize: {{size}}{{sizeFormat}}
			</div>
			<div nz-col nzSpan="24" class="size text-center">
				{{imageName}}
			</div>
		</div>
	</div>
	<div>
		<nz-divider class="m-t-5 m-b-5" nzText="OR"></nz-divider>
	</div>
	<div nz-row nzJustify="center">
		<app-custom-submit-button (click)="fileInput.click()" [submitting]="false" name="Browse Files">
		</app-custom-submit-button>
	</div>

	<div style="visibility: hidden;">
		<input #fileInput type="file" style="display: none" (change)="onFileChange($event,1)" />
	</div>
	<app-custom-error-display [errorMessage]="errorMessage"></app-custom-error-display>
</div>